import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DocumentService } from './document.service';
import { IDocument } from '@interfaces/nebula';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentResolverService implements Resolve<IDocument> {
  private logger = inject(LoggerService);
  private documentService = inject(DocumentService);


  constructor() {
    this.logger.debug('Service [document-resolver] started.');
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IDocument> {
    this.logger.debug('Document-Resolver - route: {@query} - state: {@state}', {
      query: route.queryParamMap,
      state: state.toString()
    });
    return this.documentService.getDocumentById(route.paramMap.get('documentid'));
  }
}
